import {
  ArrayMinSize,
  IsArray,
  IsIn,
  IsLatitude,
  IsLongitude,
  IsOptional,
} from "class-validator";

export const bookingUnlockIncludes = ["relays", "bluetooth"] as const;
export type BookingUnlockInclude = (typeof bookingUnlockIncludes)[number];

export function resolveBookingUnlockInclude(
  include?: BookingUnlockInclude[],
): BookingUnlockInclude[] {
  return include ?? [...bookingUnlockIncludes];
}

export class BookingStartRequest {
  @IsOptional()
  @IsLatitude()
  latitude?: number;

  @IsOptional()
  @IsLongitude()
  longitude?: number;

  /** Unlock paths to run. Omitted defaults to relays and bluetooth. */
  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @IsIn(bookingUnlockIncludes, { each: true })
  include?: BookingUnlockInclude[];
}
